import './input.scss';
import Sloth from '../Sloth';



/** WEBPACK FOOTER **
 ** ./components/Input/input.js
 **/